// import React, { useContext } from 'react'
// import { Link } from 'react-router-dom';
// import { CardContext } from '../../../store/CardContext';

// function ContactCard1({ preview, Textcolor, Iconcolor, BtIColor, controls} ) {
//     const [cardData] = useContext(CardContext)

//     const {
//         personalDetails,
//         contactDetails,
//         vCard
//     } = cardData

//     const shareMail = (e) => {
//         window.location = `mailto:${personalDetails?.email}`;
//         e.preventDefault();
//     };

//     const shareMail2 = (e) => {
//         window.location = `mailto:${personalDetails?.secondaryEmail}`;
//         e.preventDefault();
//     };
//     return (
//         <div>
//             <div>
//                 <div className="flex gap-3 mt-5 ">
//                     <div>
//                         <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                         >
//                             <path
//                                 d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
//                                 fill={Textcolor}
//                             />
//                         </svg>
//                     </div>
//                     <div style={{ color: `${Textcolor}`, }}>
//                         <p className='text-[16px] font-semibold '>Call</p>
//                         <Link
//                             to={
//                                 preview ? `tel:+${personalDetails?.phone}` : ""
//                             }
//                         >
//                             <p className="text-[#5A5A5A] font-[14px]  break-words font-normal leading-5 text-left ">
//                                 +
//                                 {personalDetails?.phone
//                                     ? personalDetails.phone
//                                     : ""}
//                             </p>
//                         </Link>

//                         <Link
//                             to={
//                                 preview ? `tel:+${personalDetails?.secondaryPhone}` : ""
//                             }
//                         >
//                             <p className="text-[#5A5A5A] font-[14px]  break-words font-normal leading-5 text-left ">

//                                 {personalDetails?.secondaryPhone
//                                     ? "+" + personalDetails.secondaryPhone
//                                     : ""}
//                             </p>
//                         </Link>
//                     </div>
//                 </div>
//                 <div className="flex gap-3 mt-5 ">
//                     <div>
//                         <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                         >
//                             <path
//                                 d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
//                                 fill={Textcolor}
//                             />
//                         </svg>
//                     </div>
//                     <div style={{ color: `${Textcolor}`, }}>
//                         <p className='text-[16px] font-semibold '>Email</p>
//                         <Link onClick={preview ? shareMail : ""} className="text-[#5A5A5A] font-[14px]  break-words font-normal leading-5 text-left ">
//                             {personalDetails?.email
//                                 ? personalDetails.email
//                                 : ""}
//                         </Link>

//                         <div className="mt-2">
//                             <Link onClick={preview ? shareMail2 : ""} className="text-[#5A5A5A] font-[14px]  break-words font-normal leading-5 text-left ">
//                                 {personalDetails?.secondaryEmail
//                                     ? personalDetails.secondaryEmail
//                                     : ""}
//                             </Link>
//                         </div>
//                     </div>
//                 </div>
//                 <div className=" flex gap-3 mt-5 ">
//                     <div>
//                         <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                         >
//                             <path
//                                 d="M12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5ZM12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2Z"
//                                 fill={Textcolor}
//                             />
//                         </svg>
//                     </div>
//                     <div style={{ color: `${Textcolor}`, }}>
//                         <p className='text-[16px] font-semibold '>Location</p>
//                         <Link
//                             to={`${preview ? contactDetails?.locationUrl : ""
//                                 }`}
//                             target={`${preview ? "_blank" : ""}`}
//                             className="blk-btn"
//                         >
//                             <p className="text-[#5A5A5A] font-[14px]  break-words font-normal leading-5 text-left ">
//                                 {contactDetails?.address
//                                     ? contactDetails.address
//                                     : ""}
//                             </p>
//                         </Link>
//                     </div>
//                 </div>
//                 {controls ? '' :
//                     <div className="flex justify-center gap-5 mt-5">
//                         {contactDetails?.locationUrl ? (
//                             <Link to={`${preview ? contactDetails?.locationUrl : ""}`}
//                                 target={`${preview ? "_blank" : ""}`}
//                             >
//                                 <button className="w-[50px] h-[40px] p-[13px] rounded-[23px]" style={{ color: `${BtIColor}`, backgroundColor: `${Iconcolor}` }}>
//                                     <svg
//                                         width="20"
//                                         height="20"
//                                         viewBox="0 0 20 20"
//                                         fill="none"
//                                         xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                         <path
//                                             d="M18.2463 3.36842C18.6355 2.35759 17.6421 1.36426 16.6313 1.75342L2.46798 7.20009C1.33465 7.63509 1.42465 9.26676 2.59798 9.57509L8.44048 11.1126C8.54764 11.1407 8.6454 11.1968 8.72374 11.2752C8.80208 11.3535 8.85819 11.4513 8.88631 11.5584L10.4238 17.4001C10.7321 18.5743 12.3638 18.6634 12.7988 17.5309L18.2463 3.36842Z"
//                                             fill={BtIColor}
//                                         />
//                                     </svg>
//                                 </button>{" "}
//                             </Link>
//                         ) : (
//                             ""
//                         )}
//                         <Link className="" to={`${preview ? vCard : ''}`}>
//                             <button className=' w-[150px] h-[40px] rounded-[23px]' style={{ color: `${BtIColor}`, backgroundColor: `${Iconcolor}` }}>
//                                 <div className="flex  flex justify-center   gap-2">
//                                     <svg
//                                         width="20"
//                                         height="20"
//                                         viewBox="0 0 20 20"
//                                         fill="none"
//                                         xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                         <path
//                                             d="M15.833 9.16683H10.833V4.16683C10.833 3.94582 10.7452 3.73385 10.5889 3.57757C10.4326 3.42129 10.2207 3.3335 9.99967 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73385 9.16634 3.94582 9.16634 4.16683V9.16683H4.16634C3.94533 9.16683 3.73337 9.25463 3.57709 9.41091C3.42081 9.56719 3.33301 9.77915 3.33301 10.0002C3.33301 10.2212 3.42081 10.4331 3.57709 10.5894C3.73337 10.7457 3.94533 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335V10.8335H15.833C16.054 10.8335 16.266 10.7457 16.4223 10.5894C16.5785 10.4331 16.6663 10.2212 16.6663 10.0002C16.6663 9.77915 16.5785 9.56719 16.4223 9.41091C16.266 9.25463 16.054 9.16683 15.833 9.16683Z"
//                                             fill={BtIColor}
//                                         />
//                                     </svg>

//                                     <p>Add contact</p>
//                                 </div>
//                             </button>
//                         </Link>
//                     </div>

//                 }
//             </div>
//         </div>
//     )
// }

// export default ContactCard1
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { RiDirectionLine } from "react-icons/ri";
import phn from "../../../../assests/img/phoneicon.svg";
import mail from "../../../../assests/img/emailicon.svg";
import loc from "../../../../assests/img/loactionicon.svg";
import moreIcon from "../../../../assests/img/more_icon.svg";

function ContactCard1({
  card,
  preview,
  Highlightcolor,
  Textcolor,
  BtIColor,
  Iconcolor,
}) {
  const [cardData] = useContext(CardContext);
  const { personalDetails, contactDetails, phoneNumbers, emailList } = cardData;

  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${card?.secondaryEmail}`;
    e.preventDefault();
  };
  const shareMail3 = (e) => {
    window.location = `mailto:${e}`;
    // e.preventDefault();
  };

  return (
    <div className="mb-4 p-2">
      {personalDetails?.phone || personalDetails.secondaryPhone ? 
      <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium border-b border-gray-300">
        <div
          className="bg-no-repeat bg-right bg-center-y"
          style={
            {
              // Remove backgroundImage if using inline SVG
              // backgroundImage: `url(${moreIcon})`,
            }
          }
        >
          {/* Inline SVG for More Icon */}
          <svg
            width="13"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 "
            height="13"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L1 9"
              stroke={BtIColor || "#888888"}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <Link
            to={preview ? `tel:+${personalDetails?.phone}` : ""}
            className="flex items-center gap-2"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 20 20"
              fill="none"
              className="mr-2 p-2"
              style={{ backgroundColor: Iconcolor || "" }} // Set background color based on Iconcolor
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7143 0.713867H4.28575C3.49677 0.713867 2.85718 1.35346 2.85718 2.14244V17.8567C2.85718 18.6457 3.49677 19.2853 4.28575 19.2853H15.7143C16.5033 19.2853 17.1429 18.6457 17.1429 17.8567V2.14244C17.1429 1.35346 16.5033 0.713867 15.7143 0.713867Z"
                stroke={BtIColor || "#888888"} // Stroke color based on BtIColor
                strokeWidth="1.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.92896 15.7139H11.0718"
                stroke={BtIColor || "#888888"} // Same stroke color for this path
                strokeWidth="1.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className="flex flex-col">
              <span style={{ color: Textcolor || "black" }}>
                +{personalDetails?.phone || "123 456 7890"}
              </span>
              {card?.secondaryPhone && (
                <Link
                  style={{ color: Textcolor || "" }}
                  to={preview ? `tel:+${card.secondaryPhone}` : ""}
                >
                  +{card.secondaryPhone}
                </Link>
              )}
            </div>
          </Link>
        </div>
      </div>
      : null }

      {/* -------------- NEW PHONE ------ */}
      {phoneNumbers?.map((phone) => {
        return (
          <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium border-b border-gray-300">
            <div
              className="bg-no-repeat bg-right bg-center-y"
              style={
                {
                  // Remove backgroundImage if using inline SVG
                  // backgroundImage: `url(${moreIcon})`,
                }
              }
            >
              {/* Inline SVG for More Icon */}
              <svg
                width="13"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 "
                height="13"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L5 5L1 9"
                  stroke={BtIColor || "#888888"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className="flex items-center gap-2">
                {(phone?.alignCol || !phone?.showLabel) && (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 20 20"
                    fill="none"
                    className="mr-2 p-2"
                    style={{ backgroundColor: Iconcolor || "" }} // Set background color based on Iconcolor
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7143 0.713867H4.28575C3.49677 0.713867 2.85718 1.35346 2.85718 2.14244V17.8567C2.85718 18.6457 3.49677 19.2853 4.28575 19.2853H15.7143C16.5033 19.2853 17.1429 18.6457 17.1429 17.8567V2.14244C17.1429 1.35346 16.5033 0.713867 15.7143 0.713867Z"
                      stroke={BtIColor || "#888888"} // Stroke color based on BtIColor
                      strokeWidth="1.42857"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.92896 15.7139H11.0718"
                      stroke={BtIColor || "#888888"} // Same stroke color for this path
                      strokeWidth="1.42857"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
                <div
                  className={`flex ${
                    phone?.alignCol
                      ? "flex-col gap-1"
                      : "flex-row gap-2 justify-between"
                  }break-words overflow-hidden`}
                >
                  {phone?.showLabel && (
                    <label className="break-words">{phone?.label}</label>
                  )}
                  <Link
                    style={{ color: Textcolor || "" }}
                    to={preview ? `tel:+${phone?.number}` : ""}
                    className="break-all overflow-hidden text-ellipsis"
                  >
                    +{phone?.number}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}
{personalDetails?.email || personalDetails?.secondaryEmail ? 
      <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium border-b border-gray-300">
        <div
          className=""
          style={
            {
              // Remove backgroundImage if using inline SVG
              // backgroundImage: `url(${moreIcon})`,
            }
          }
        >
          {/* Inline SVG for More Icon */}
          <svg
            width="13"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 "
            height="13"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L1 9"
              stroke={BtIColor || "#888888"}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div className="">
            <Link
              onClick={preview ? shareMail : ""}
              className="flex items-center gap-2 py-2.5 text-sm font-medium "
            >
              <svg
                width="30"
                height="30"
                style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}
                className="mr-2 p-2"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8572 1.5H2.14293C1.35395 1.5 0.714355 2.13959 0.714355 2.92857V15.0714C0.714355 15.8604 1.35395 16.5 2.14293 16.5H17.8572C18.6462 16.5 19.2858 15.8604 19.2858 15.0714V2.92857C19.2858 2.13959 18.6462 1.5 17.8572 1.5Z"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M0.714355 3.28613L9.08578 10.429C9.34248 10.6428 9.66599 10.7599 10.0001 10.7599C10.3341 10.7599 10.6577 10.6428 10.9144 10.429L19.2858 3.28613"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className="flex-col flex">
                <span style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {personalDetails?.email || "john@example.com"}
                </span>
                {card?.secondaryEmail ? (
                  <Link
                    style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}
                    onClick={preview ? shareMail2 : ""}
                  >
                    {card?.secondaryEmail}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </Link>
          </div>
        </div>
      </div>
      :null }
      {emailList?.map((email) => {
          return (
      <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium border-b border-gray-300">
        <div
          className=""
          style={
            {
              // Remove backgroundImage if using inline SVG
              // backgroundImage: `url(${moreIcon})`,
            }
          }
        >
          {/* Inline SVG for More Icon */}
          <svg
            width="13"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 "
            height="13"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L1 9"
              stroke={BtIColor || "#888888"}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div className="">
            <Link
               onClick={() => {
                shareMail3(email.email);
              }}
              className="flex items-center gap-2 py-2.5 text-sm font-medium "
            >
               {(email?.alignCol || !email?.showLabel) && (
              <svg
                width="30"
                height="30"
                style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}
                className="mr-2 p-2"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8572 1.5H2.14293C1.35395 1.5 0.714355 2.13959 0.714355 2.92857V15.0714C0.714355 15.8604 1.35395 16.5 2.14293 16.5H17.8572C18.6462 16.5 19.2858 15.8604 19.2858 15.0714V2.92857C19.2858 2.13959 18.6462 1.5 17.8572 1.5Z"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M0.714355 3.28613L9.08578 10.429C9.34248 10.6428 9.66599 10.7599 10.0001 10.7599C10.3341 10.7599 10.6577 10.6428 10.9144 10.429L19.2858 3.28613"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
   )}     <div
                         className={`flex ${
                           email?.alignCol ? "flex-col gap-1" : "flex-row gap-1"
                         }  break-words overflow-hidden`}
                       >
                         {email?.showLabel && (
                           <label className="break-words">{email?.label} :</label>
                         )}
                         <Link
                           style={{ color: Textcolor || "" }}
                           onClick={() => {
                            shareMail3(email.email);
                          }}
                          //  to={preview ? `tel:+${email?.email}` : ""}
                           className="break-all overflow-hidden text-ellipsis"
                         >
                           {email?.email}
                         </Link>
                       </div>
            </Link>
          </div>
        </div>
      </div>
     );
    })}

      {card?.address && (
        <div className="addressContainer mt-2 flex flex-col">
          <svg
            width="13"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 "
            height="13"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L1 9"
              stroke={BtIColor || "#888888"}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div className="flex items-center mb-2 w-full">
            <svg
              style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}
              width="30"
              className="mr-2 p-2"
              height="30"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4284 7.14342C14.4284 10.7006 7.99986 19.2863 7.99986 19.2863C7.99986 19.2863 1.57129 10.7006 1.57129 7.14342C1.57129 5.43845 2.24858 3.80332 3.45417 2.59773C4.65976 1.39214 6.2949 0.714844 7.99986 0.714844C9.70482 0.714844 11.34 1.39214 12.5455 2.59773C13.7511 3.80332 14.4284 5.43845 14.4284 7.14342V7.14342Z"
                stroke={BtIColor ? BtIColor : "#888888"}
                stroke-width="1.42857"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.99955 9.28669C9.18301 9.28669 10.1424 8.3273 10.1424 7.14383C10.1424 5.96037 9.18301 5.00098 7.99955 5.00098C6.81608 5.00098 5.85669 5.96037 5.85669 7.14383C5.85669 8.3273 6.81608 9.28669 7.99955 9.28669Z"
                stroke={BtIColor ? BtIColor : "#888888"}
                stroke-width="1.42857"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              className="w-[75%] ml-2"
              style={{ color: Textcolor || "black" }}
            >
              {card?.address}
            </span>
          </div>

          {card?.locationUrl && (
            <Link
              to={preview ? card?.locationUrl : "#"}
              target={preview ? "_blank" : ""}
              className="w-full"
            >
              <button
                // onClick={onClick}
                className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
                style={{
                  backgroundColor: Highlightcolor || "black",
                  color: Textcolor || "black",
                }}
              >
                <RiDirectionLine
                  className="mr-2"
                  size={18}
                  style={{ color: Textcolor || "black" }}
                />
                <span
                  className="font-medium text-[12px]"
                  style={{ color: Textcolor || "black" }}
                >
                  Directions
                </span>
              </button>
            </Link>
          )}
        </div>
      )}
      {/* {contactDetails?.locationUrl ? (
         <div
         className="bg-no-repeat bg-right-top  mt-4"
         style={{ backgroundImage: `url(${moreIcon})`  }}
       >
         <Link
           to={preview ? contactDetails?.locationUrl : ""}
           target={preview ? "_blank" : ""}
           className="block  pb-3" // Ensures the button fills the entire Link area
           style={{ textDecoration: 'none' }} // Optional: Removes underline
         >
           <div className="flex items-center gap-2 py-2.5 text-sm font-medium ">
           <svg    style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}   width="30"    className="mr-2 p-2"
      height="30"  viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"   >
    <path d="M14.4284 7.14342C14.4284 10.7006 7.99986 19.2863 7.99986 19.2863C7.99986 19.2863 1.57129 10.7006 1.57129 7.14342C1.57129 5.43845 2.24858 3.80332 3.45417 2.59773C4.65976 1.39214 6.2949 0.714844 7.99986 0.714844C9.70482 0.714844 11.34 1.39214 12.5455 2.59773C13.7511 3.80332 14.4284 5.43845 14.4284 7.14342V7.14342Z"   stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.99955 9.28669C9.18301 9.28669 10.1424 8.3273 10.1424 7.14383C10.1424 5.96037 9.18301 5.00098 7.99955 5.00098C6.81608 5.00098 5.85669 5.96037 5.85669 7.14383C5.85669 8.3273 6.81608 9.28669 7.99955 9.28669Z"   stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
    
             <span style={{color: `${Textcolor ? Textcolor : "black"}`}}>{contactDetails?.address || "2709 Hwy 51, Janesville"}</span>
           </div>
       
           <div
             className="w-full h-[44px] py-2 px-4 mt-3 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300"
             style={{
               backgroundColor: Highlightcolor || "black",
               color: Textcolor || "white",
             }}
           >
             <RiDirectionLine className="mr-2" size={18} />
             <span style={{color: `${Textcolor ? Textcolor : "black"}`}} className="font-medium text-xs">Directions</span>
           </div>
         </Link>
       </div>
       
          ) : (
            <div
              className="bg-no-repeat bg-right-top"
              style={{ backgroundImage: `url(${moreIcon})` }}
            >
              <Link className="flex items-center gap-2 py-2.5 text-sm font-medium ">
                <img src={loc} alt="Location" className="mr-2" />
               
              </Link>
            </div>
          )} */}
    </div>
  );
}

export default ContactCard1;
